var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 5.2917 5.2917",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -291.71)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.31551 296.68c-0.15497-0.15497-0.17753-0.27424-0.15531-0.82092 0.025258-0.62144 0.032805-0.6404 0.26568-0.66728 0.23567-0.0272 0.24012-0.0183 0.26624 0.53249l0.026566 0.56015h3.9049v-3.8162h-3.9049l-0.026566 0.56015c-0.02613 0.55077-0.030591 0.55969-0.26624 0.53249-0.23287-0.0269-0.24042-0.0458-0.26568-0.66727-0.041942-1.0318-0.1161-1.0022 2.5109-1.0022 2.056 0 2.184 0.01 2.3518 0.17749 0.16764 0.16764 0.1775 0.29583 0.1775 2.3075 0 2.0116-0.00986 2.1398-0.1775 2.3074-0.16783 0.16783-0.29583 0.17749-2.3518 0.17749-2.0712 0-2.1829-9e-3 -2.3556-0.1813zm2.0007-1.1498c-0.15652-0.17295-0.15191-0.18583 0.18238-0.51031l0.34295-0.33288-2.6997-0.049v-0.52324l2.6997-0.049-0.34597-0.33581-0.34597-0.33582 0.39017-0.39016 1.3709 1.3709-0.66192 0.66637c-0.36405 0.36649-0.68668 0.66636-0.71695 0.66636-0.030255 0-0.12728-0.0798-0.21559-0.17742z",
    strokeWidth: 0.088748,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.4974ad16.svg";
export { ForwardRef as ReactComponent };